import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";

import Subtitle from "components/SubTitle";
import Icon from "components/Icon";
import Col from "components/Grid/Col";
import Row from "components/Grid/Row";
import Button from "components/Button";
import ImgLogo from "components/Icon/png/AIO-logo.png";
import FileModal from "components/FileModal";

import { GlobalAuthContext, GlobalLoaderContext } from "store/context";
import { FitinsurAPI, MessageCenter } from "utils";
import Colors from "constants/Colors";

import {
  Container,
  Content,
  ButtonContainer,
  FieldLabel,
  Head,
  Heading,
  Subtitle2,
  Title,
  Logo,
  BackToList
} from "./styles";

export default function Certificate(props) {

  const [statusOperation, setStatusOperation] = useState(null);
  const [files, setFiles] = useState([]);
  const { idProduct } = props.match.params;
  const { idOperation } = props.match.params;
  const history = useHistory();
  const fitinsurAPI = new FitinsurAPI();
  const mc = new MessageCenter();

  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);

  useEffect(() => {
    if (authContext.status !== true) {
      mc.error("Usuário não autenticado");
      history.push("/login");
      return;
    }

    async function handleRequests() {
      const DOMAIN_DOCUMENT_CERTIFICADO = 23;
      fitinsurAPI.setAuthToken(authContext.token)
      fitinsurAPI.requestListDocumentsDomain(idOperation, DOMAIN_DOCUMENT_CERTIFICADO)
        .then(data => data.json())
        .then(response => {
          console.log("requestListDocumentsDomain response", response);
          if (response.ret_code == 200) {
            if (response.ret_value
              && response.ret_value.length > 0
              && response.ret_value[0].urlLink) {
              setFiles(files => [...files, {
                html: `${response.ret_value[0].urlLink}#toolbar=1&view=FitH",`,
                title: response.ret_value[0].nameFile
              }]);
              return;
            };
          };
          console.log("Erro ao processar requestListDocumentsDomain: " + JSON.stringify(response));
          return;
        })
        .catch(error => {
          console.log("Error on call requestListDocumentsDomain: ", error);
          return {};
        });
    }
    handleRequests();
  }, []);

  return (
    <Container>
      <Head>
        <Row>
          <Col className="d-sm-none" style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
            <Logo user={authContext.username}></Logo>
          </Col>
          <Col sm={12}>
            <Title>Seguro Efetivado com Sucesso</Title>
            <Subtitle2>RESPONSABILIDADE CIVIL PROFISSIONAL DENTISTAS</Subtitle2>
          </Col>
        </Row>
        <Logo user={authContext.username} className="d-none d-sm-block p-0 p-md-2"></Logo>
      </Head>

      <Subtitle
        idProduct={idProduct}
        idOperation={props?.match?.params?.idOperation}
        statusOperation={statusOperation}
        stage={3}
        activeColor={Colors.PRIMARY}
        cantGoBack={true}
      />
      <Content>

        <FieldLabel style={{ marginTop: "35px" }}>
          <b>Faça o dowload do Certificado</b> abaixo para salvar no seu computador.
        </FieldLabel>
        <FieldLabel style={{ marginBottom: "35px" }}>
          Em breve você receberá o kit de boas vindas com a apólice do seu seguro.
        </FieldLabel>

        <FileModal isPDF={true} file={files} color={Colors.TITLE} />

      </Content>
    </Container >
  );
}
